var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content mt-4"},[_c('div',{staticClass:"table"},[_c('Table',{attrs:{"config":_vm.config,"rows":_vm.transactionLineItems,"total":_vm.totalTransactionLineItems},scopedSlots:_vm._u([{key:"effectiveDate",fn:function(ref){
var item = ref.item;
return [(item.effectiveDate)?_c('span',[_vm._v(_vm._s(_vm.formatDate(item.effectiveDate)))]):_vm._e()]}},{key:"billingDate",fn:function(ref){
var item = ref.item;
return [(item.postingDate)?_c('span',[_vm._v(_vm._s(_vm.formatDate(item.billingDate)))]):_vm._e()]}},{key:"description",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.description))])]}},{key:"dateFrom",fn:function(ref){
var item = ref.item;
return [(item.dateFrom)?_c('span',[_vm._v(_vm._s(_vm.formatDate(item.dateFrom)))]):_vm._e()]}},{key:"dateTo",fn:function(ref){
var item = ref.item;
return [(item.dateTo)?_c('span',[_vm._v(_vm._s(_vm.formatDate(item.dateTo)))]):_vm._e()]}},{key:"unitAmount",fn:function(ref){
var item = ref.item;
return [_c('strong',[_vm._v(_vm._s(_vm._f("currency")(item.unitAmount)))])]}},{key:"numberOfUnits",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.numberOfUnits))])]}},{key:"totalAmount",fn:function(ref){
var item = ref.item;
return [_c('strong',[_vm._v(_vm._s(_vm._f("currency")(item.totalAmount)))])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }